/**
 * Кадр overlay и его вписывание в окно browser source.
 *
 * ГЕОМЕТРИЯ ЖИВЁТ НЕ ЗДЕСЬ. С Фазы 4 константы кадра и охранные зоны TikTok
 * объявлены в `@efira/game-sdk/frame` и реэкспортируются отсюда. Причина не в
 * стройности: охранные зоны нужны трём потребителям сразу - watermark и HUD в
 * overlay и редактору раскладки в dashboard, - а dashboard импортировать из
 * `apps/overlay` не может вовсе. Копия зон в редакторе разошлась бы с копией в
 * overlay молча, и стример, поставивший таблицу по границе зоны в редакторе,
 * увидел бы её под чатом в эфире.
 *
 * docs/ARCHITECTURE.md, 5.1: кадр 1080 x 1920, всё дерево масштабируется одним
 * преобразованием на корне:
 *
 *     scale      = min(W / 1080, H / 1920)
 *     translateX = (W - 1080 * scale) / 2
 *     translateY = (H - 1920 * scale) / 2
 *
 * Свойства: строго пропорциональное масштабирование, ни перекомпоновки, ни
 * обрезки; при другом соотношении сторон кадр вписывается целиком и
 * центрируется, свободное место остаётся прозрачным.
 */

export {
  FRAME_HEIGHT,
  FRAME_WIDTH,
  TIKTOK_GUARD,
  WATERMARK_BOX,
  computeFrameTransform,
  overlapsGuard,
  safeArea,
  watermarkBox,
} from '@efira/game-sdk/frame';
export type {
  ElementPlacement,
  FrameTransform,
  GuardRect,
  OverlayLayout,
} from '@efira/game-sdk/frame';

import type { FrameTransform } from '@efira/game-sdk/frame';

/** CSS-значение `transform` для корня кадра. Порядок операций - как в формуле. */
export function frameTransformStyle({ scale, translateX, translateY }: FrameTransform): string {
  return `translate(${translateX}px, ${translateY}px) scale(${scale})`;
}
